function removeLeadingZero(value) {
  return String(Number(value) || '');
}
export function deserialize(value) {
  if (!value) {
    return {
      year: '',
      month: '',
      day: ''
    };
  }
  const [date, time] = value.split(' ');
  const dateParts = date.split('-');
  return {
    time,
    year: dateParts[0],
    month: removeLeadingZero(dateParts[1]),
    day: removeLeadingZero(dateParts[2])
  };
}
export function serialize(value, datePart, currentDate) {
  const newYear = datePart === 'year' ? value : currentDate.year;
  const newMonth = datePart === 'month' ? value : currentDate.month;
  const newDay = datePart === 'day' ? value : currentDate.day;
  const newTime = datePart === 'time' ? value : currentDate.time;
  const yearFormatted = newYear || '';
  const monthFormatted = newMonth ? newMonth.padStart(2, '0') : '';
  const dayFormatted = newDay ? newDay.padStart(2, '0') : '';
  const date = [yearFormatted, monthFormatted, dayFormatted].join('-');
  if (!newTime) {
    return date;
  }
  return date + " " + newTime;
}
export function isDateTimeFieldElement(element) {
  if (!element) {
    return false;
  }
  if (element.dataset.datetimeField) {
    return true;
  }

  /**
   * awful workaround for ui-tpa Dropdown
   * checks all ancestors for month data hook
   * TPADropdown doesn't have a way to pass attributes to the focusable button element
   */
  return element.closest('[data-hook*="-month"]');
}
//# sourceMappingURL=helpers.js.map